<template>
  <div class="Trainee-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="Trainee-modal" @click.stop>
        <div class="Evaluation-modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <div class="saved-groups-container">
            <h3 class="page-title" style="font-size: 1.75rem; margin-bottom: 20px; margin-left: 10px; text-align: left;">Saved Groups 
              <span class="project-name">
                for session: {{ project.name }}
              </span>
            </h3>
            <table v-if="groups.length > 0" class="data-table-trainee">
              <thead>
                <tr>
                  <th>Group Name</th>
                  <th style="width: 150px;">Members</th>
                  <th style="width: 300px;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="group in groups" :key="group.group_id">
                  <td>{{ group.name }}</td>
                  <td>{{ group.trainees.length }}</td>
                  <td class="center-icons">
                    <font-awesome-icon icon="eye" class="eye-icon" title="View list of Trainees in the Group" @click="viewGroupTrainees(group)" />
                    <font-awesome-icon icon="trash-alt" class="delete-icon" title="Delete Group" @click="deleteGroup(group.group_id)" />
                    <font-awesome-icon icon="edit" class="edit-icon" @click="editGroup(group)" title="Edit Group" />
                    <button class="generatePDFButton" @click="selectGroupTrainees(group)" style="margin-left: 20px;">
                      Select
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-else style="text-align: center; padding: 20px; font-style: italic; color: #777; border: 1px solid #dddddd; border-radius: 3px;">
              No saved groups found for this session. Click 'Create new Group' to save a group of trainees.
            </p>
          </div>
          <div class="create-group-button-container" style="margin-top: 20px; text-align: left;">
            <button class="btn btn-primary" @click="openSelectGroupTraineesModal()">
              Create New Group
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <transition name="modal-fade">
    <div v-if="showTraineesModal" class="Trainee-modal-overlay" @click.self="showTraineesModal = false">
      <div class="Trainee-modal small-modal">
        <div class="modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <h3>{{ selectedGroupName }} - Trainees</h3>
          <table class="data-table-trainee">
            <thead>
              <tr>
                <th>ID</th>
                <th>First Name</th>
                <th>Last Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="t in traineesInSelectedGroup" :key="t.user_id">
                <td>{{ t.user_id }}</td>
                <td>{{ t.first_name }}</td>
                <td>{{ t.last_name }}</td>
              </tr>
              <tr v-if="traineesInSelectedGroup.length === 0">
                <td colspan="4" style="text-align: center;">No trainees in this group.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </transition>
  <select-group-trainees-modal v-if="showSelectGroupTraineesModal" :propTrainees="trainees" :propGroups="groups"
    :initialSelected="selectedTraineeIds" :initialGroupName="groupName" :isEditing="isEditingGroup"
    :editingGroupId="editingGroupId" @confirm="handleTraineesSelected" @close="closeSelectGroupTraineesModal" />
</template>

<script>
import axios from 'axios';
import SelectGroupTraineesModal from './SelectGroupTraineesModal.vue';


export default {
  name: 'SelectGroupModal',
  components: {
    SelectGroupTraineesModal,
  },
  props: {
    propTrainees: {
      type: Array,
      required: true,
    },
    initialSelected: {
      type: Array,
      required: true,
    },
    project: {
      type: Array,
      required: true,
    },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      trainees: [],
      selectedTraineeIds: [],
      groups: [],
      instructorId: parseInt(localStorage.getItem('user_id')),
      projectId: parseInt(localStorage.getItem('projectId')),
      sortField: 'user_id',
      sortDirection: 'asc',
      searchQuery: '',
      sessionSearchQuery: '',
      currentPage: 1,
      perPage: 30,
      totalPages: 0,
      filteredTraineesLength: null,
      isVisible: false,
      selectAll: false,
      groupName: '',
      showConfirmationModal: false,
      wantsToSaveGroup: false,
      showTraineesModal: false,
      traineesInSelectedGroup: [],
      selectedGroupName: '',
      showSelectGroupTraineesModal: false,
      isEditingGroup: false,
      editingGroupId: null,
    };
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      const end = this.startIndex + this.perPage;
      return end < this.filteredTraineesLength ? end : this.filteredTraineesLength;
    },
    filteredTrainees() {
      return this.computeFilteredTrainees();
    },
    selectedTraineeObjects() {
      const set = new Set(this.selectedTraineeIds.map(Number));
      return this.trainees.filter(t => set.has(Number(t.user_id)));
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
      }
    },
    selectedTraineeIds(newVal) {
      const filtered = this.trainees.filter((trainee) => {
        const fullName = `${trainee.first_name || ''} ${trainee.last_name || ''}`.toLowerCase();
        return fullName.includes(this.searchQuery.toLowerCase()) || this.searchQuery === '';
      });

      const allFilteredIds = filtered.map(t => Number(t.user_id));
      const selectedSet = new Set(newVal.map(Number));

      this.selectAll = allFilteredIds.length > 0 && allFilteredIds.every(id => selectedSet.has(id));
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async fetchGroups() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const response = await axios.get(`/api/instructors/${this.instructorId}/projects/${this.projectId}/groups`, { headers });
        this.groups = response.data;
        console.log('groups', response);
      } catch (error) {
        console.error('Failed to load groups', error);
      }
    },
    viewGroupTrainees(group) {
      this.traineesInSelectedGroup = group.trainees;
      this.selectedGroupName = group.name;
      this.showTraineesModal = true;
    },
    selectGroupTrainees(group) {
      this.selectedTraineeIds = group.trainees.map(t => Number(t.user_id));
      const selected = this.trainees.filter(t =>
        this.selectedTraineeIds.includes(Number(t.user_id))
      );
      this.$emit('confirm', selected);
      this.close();
    },
    editGroup(group) {
      this.isEditingGroup = true;
      this.editingGroupId = group.group_id;
      this.selectedTraineeIds = group.trainees.map(t => t.user_id);
      this.groupName = group.name;

      this.showSelectGroupTraineesModal = true; // Open the modal
    },
    async deleteGroup(groupId) {
      if (!confirm('Are you sure you want to delete this group?')) return;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const response = await axios.delete(`/api/groups/${groupId}`, { headers });
        if (response.status === 200) {
          this.groups = this.groups.filter(g => g.group_id !== groupId);
          alert('Group deleted successfully');
        }
      } catch (error) {
        console.error('Failed to delete group', error);
        alert('Error deleting group');
      }
    },
    openSelectGroupTraineesModal() {
      this.selectedTraineeIds = [];
      this.showSelectGroupTraineesModal = true;
    },
    closeSelectGroupTraineesModal() {
      this.showSelectGroupTraineesModal = false;
      this.isEditingGroup = false;
      this.editingGroupId = null;
      this.groupName = '';
      this.fetchGroups();
    },
    handleTraineesSelected(selected) {
      this.selectedTraineeIds = selected.map(x => Number(x.user_id ?? x));

      this.showSelectGroupTraineesModal = false;
    }
  }, async mounted() {
    this.isVisible = true;
    this.trainees = this.propTrainees;
    // Extract user_ids from initialSelected and assign them
    this.selectedTraineeIds = this.initialSelected.map(t => Number(t.user_id));
    await this.fetchGroups();
  }
};
</script>

<style scoped>
.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Trainee-modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.Trainee-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  max-width: 90vw;
  max-height: 94vh;
  min-width: max(60vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin: 0px;
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.assessment-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}

span:hover {
  cursor: pointer;
  color: blue;
}

.pagination-container {
  display: flex;
  margin-left: 3%;

}

.container-fluid {
  padding-top: 5px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.search-container {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-size: 16px;
  width: 80%;
}

button.btn {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0%;
  margin-bottom: 0px;
  border: 1px solid rgb(0, 45, 63);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
  margin-right: 30px;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

.heading h1 {
  padding-top: 30px;
  padding-bottom: 10px;
  text-align: center;
  padding-left: 3%;

}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  float: left;
  margin-left: 30px;
  border: 2px solid black;
  padding: 3px;
}

button:hover {
  background-color: #7c927a;
  transition: transform 0.2s, box-shadow 0.2s;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top: 100px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}

/* Data table styles */
.data-table-trainee {
  width: 99%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin-top: 0;
  align-items: left;
  margin-bottom: 30px;
}

.data-table-trainee th {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  color: rgb(107, 107, 107);
  background-color: rgba(219, 219, 219, 0.804);
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee tbody tr:nth-child(odd) {
  background-color: white;
}

.data-table-trainee tbody tr:nth-child(even) {
  background-color: rgba(219, 219, 219, 0.804);
}


.data-table-trainee td {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  font-weight: 500;
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee,
.data-table-trainee th,
.data-table-trainee td {
  border: 1px solid black;
}

.data-table-trainee th,
.data-table-trainee td {
  padding: 8px;
}

.data-table-trainee td.center-icons {
  text-align: center;
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.save-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #0157b3;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.save-button:hover {
  background-color: #0462c7;
}

.submit-button {
  background-color: brown;
  border: 1px solid rgb(99, 15, 15);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 20px;
  min-width: 100px;
  max-width: 120px;
}

.submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.cancel-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
}

.cancel-button:hover {
  background-color: #545a5f;
}

.clear-button {
  background-color: #ee9581;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 20px;
  width: 100%;
  min-width: 60px;
  max-width: 100px;
  border: 1px solid #c7715e;
  height: 30px;
  padding: 0px;
}

.clear-button:hover {
  background-color: #e47a62;
}

.edit-icon,
.eye-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  margin-left: 20px;
}

.edit-icon:hover,
.eye-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */
}

span {
  border: 0px;
}

span:hover {
  border: 0px;
  color: rgb(17, 17, 17);
  cursor: auto;
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  padding-left: 15px;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.select-group-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  margin-left: 5px;
  border-radius: 4px;
  cursor: pointer;
}

.select-group-button:hover {
  background-color: #0056b3;
}

.small-modal {
  max-width: 900px;
  /* Smaller width */
  min-width: 700px;
  max-height: 90vh;
  /* Limit height */
  overflow-y: auto;
  padding: 15px;
  border-radius: 8px;
}

.create-group-modal {
  max-width: 95vw;
  /* Wider */
  max-height: 95vh;
  /* Taller */
  min-width: max(70vw, 1200px);
  /* Larger minimum width */
  padding: 30px;
  /* More padding */
}

.generatePDFButton {
  border-radius: 5px;
  background-color: #c8e1fa;
  font-size: 13px;
  padding: 3px 7px 3px 7px;
  width: auto;
  border: 1px solid #1c4e80;
}

.generatePDFButton:hover {
  background-color: #afc5db;
  cursor: pointer;
}

.page-title {
  text-align: left;
}

.project-name {
  /* display: block; */
  font-size: 20px !important;
  color: #7e828c;
}

.project-name:hover {
  color: #70747c !important;
}
</style>